<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Applications</template>
        </page-header>
        <pro-table
            :resource="resource"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="name"
            direction="ASC"
            delete-label="name"
            :actions="actions"
            :permissions="true"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../mixins/DataTableSetup';
    import axios from 'axios'

    export default {
        name: "Applications",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'application-forms',
                numberOfFilters: 2,
                pageActions: {},
                fields: [
                    {
                        name: 'Name',
                        column: 'name',
                        route: '/application-forms/{id}/view',
                        linked: true,
                        sortCol: 'name'
                    },
                    {
                        name: 'Allocation',
                        column: 'budget_formatted',

                    },
                    {
                        name: 'Used',
                        column: 'money.used',
                    },
                    {
                        name: 'Remaining',
                        column: 'money.remaining',
                    },
                    {
                        name: 'Start',
                        column: 'start',
                         align: 'center'
                    },
                    {
                        name: 'End',
                        column: 'end',
                         align: 'center'
                    },
                    {
                        name: 'Approved',
                        column: 'applicationForms.approved',
                        align: 'center'
                    },
                    {
                        name: 'Pending',
                        column: 'applicationForms.pending',
                        align: 'center'
                    },
                    {
                        name: 'Incomplete',
                        column: 'applicationForms.incomplete',
                        align: 'center'
                    },
                    {
                        name: 'Completed',
                        column: 'applicationForms.completed',
                        align: 'center'
                    },
                    {
                        name: 'Status',
                        column: 'active',
                        align: 'center',
                    },
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'View', link: 'view', icon: 'eye',  type: 'router-link', tooltip: 'View', permissions: 'application-forms.show' },
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'application-forms.edit' },
                        { label: 'Duplicate', method: 'duplicate', icon: 'copy', type: 'method', tooltip: 'Duplicate', permissions: 'application-forms.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'application-forms.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
            duplicate: function(payload){
                this.$store.commit('TOGGLE_BACKDROP', {open: true});

                axios.post(process.env.VUE_APP_API_URL + '/application-forms/' + payload.item.id + '/duplicate').then(response => {
                    this.$store.commit('TOGGLE_BACKDROP', {open: false});

                    if (response.data.success){
                        this.$router.push(`/application-forms/${response.data.data.id}/edit`);
                    }
                })
            }
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            // Application Status Filter
            const applicationStatusTypesFilter = {
                label: 'Status',
                name: 'active',
                type: 'select',
                options: [
                    { label: 'Active', value: '1' },
                    { label: 'Inactive', value: '0' }
                ],
                width: 'w-1/4',
                value: this.applicationStatusTypeValue,
                placeholder: 'Select Status...'
            };

            this.filters.push(applicationStatusTypesFilter);

            this.pageActions = {
                buttons: [
                    {
                        label: 'New Application',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/application-forms/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('application-forms.edit') !== -1
                    },
                    {
                        label: 'Re-Order',
                        icon: 'sort',
                        type: 'router-link',
                        link: '/application-forms/order',
                        iconClass: 'text-gray-800',
                        display: this.$store.getters.permissions.indexOf('application-forms.edit') !== -1
                    }
                ],
                additional: []
            }
        },
        computed: {
            applicationStatusTypeValue(){
                const filters = this.$store.getters.filters;

                if (filters.applicationForms.active){
                    return filters.applicationForms.active;
                } else {
                    return '1';
                }
            },
            searchValue () {
                const filters = this.$store.getters.filters;

                if (filters.applicationForms.search){
                    return filters.applicationForms.search.value;
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
